import { useQuery } from "@apollo/client";
import { Box, Grid } from "@mui/material";
import TableHeader from "common/Table/TableHeader";
import DetailCard from "common/detailElement/DetailCard";
import React from "react";
import { GET_SINGLE_BMI_TRACKS } from "./graphql/query";
import Toaster from "common/Toaster";
import DetailPageLoading from "common/detailElement/DetailPageLoading";
import { useParams } from "react-router-dom";
import DetailList from "common/detailElement/DetailList";
import moment from "moment";
import {
  Event,
  Height,
  MonitorHeart,
  PermContactCalendar,
  Person,
  Scale,
  Troubleshoot,
} from "@mui/icons-material";

const iconStyle = { color: "rgba(0,0,0,0.7)" };

const BMITracksDetail = () => {
  const { id } = useParams();

  const { data, loading } = useQuery(GET_SINGLE_BMI_TRACKS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    skip: id ? false : true,
    variables: { objectId: id },
    onError: (error) => {
      Toaster({
        type: "error",
        message: error.message,
      });
    },
  });

  if (loading) {
    return <DetailPageLoading />;
  }

  return (
    <Box>
      <TableHeader title="BMI Track Detail" />
      <DetailCard>
        <Grid container>
          <Grid item xs={12} md={6}>
            <DetailList
              title="Member"
              data={data?.BMITrack?.member?.user?.name ?? "-"}
              icon={<Person sx={iconStyle} />}
            />
            <DetailList
              title="BMI"
              data={data?.BMITrack?.BMI ?? "-"}
              icon={<MonitorHeart sx={iconStyle} />}
            />
            <DetailList
              title="Weight Status"
              data={data?.BMITrack?.weightStatus ?? "-"}
              icon={<Troubleshoot sx={iconStyle} />}
            />
            <DetailList
              title="Date"
              data={
                data?.BMITrack?.date
                  ? moment(data?.BMITrack?.date).format("DD MMM YYYY")
                  : "-"
              }
              icon={<Event sx={iconStyle} />}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <DetailList
              title="Weight"
              data={
                data?.BMITrack?.weight ? `${data?.BMITrack?.weight} kg` : "-"
              }
              icon={<Scale sx={iconStyle} />}
            />
            <DetailList
              title="Height"
              data={
                data?.BMITrack?.height
                  ? `${(data?.BMITrack?.height).toFixed(2)} cm`
                  : "-"
              }
              icon={<Height sx={iconStyle} />}
            />
            <DetailList
              title="Age"
              data={data?.BMITrack?.age ?? "-"}
              icon={<PermContactCalendar sx={iconStyle} />}
            />
          </Grid>
        </Grid>
      </DetailCard>
    </Box>
  );
};

export default BMITracksDetail;
